import { useDispatch } from 'react-redux'
import { InformationCircleIcon } from '@heroicons/react/24/outline'
import { PencilIcon } from '@heroicons/react/24/solid'
import { formatPhoneNumber } from '@/utils/formatters'
import { Input, Modal } from '@/components/ui'
import Address from "@/components/Address"
import EmailLink from '@/components/EmailLink'
import { setCurrentPrestataire, setEmptyCurrentPrestataire } from './prestatairesSlice'
import Form from './Form'

export default ({item, withLabel = true}) => {
  const dispatch = useDispatch()

  const { isOpen, handleShow, handleHide, dialogRef } = Modal.useModal()

  const openModal = () => {
    dispatch(setCurrentPrestataire(item))
    handleShow()
  }

  const closeModal = () => {
    dispatch(setEmptyCurrentPrestataire())
    handleHide()
  }

  const Content = () => (
    <div className="flex items-center">
      <span className="uppercase">{item.nom_complet}</span>
      <div className="dropdown dropdown-hover">
        <div tabIndex={0} role="button" className="btn btn-circle btn-ghost btn-xs m-1"><InformationCircleIcon className="size-5" /></div>
        <div tabIndex={0} className="card dropdown-content w-80 bg-base-100 rounded-box z-1 p-2 shadow-sm">
          <div tabIndex={0} className="card-body">
            <h3 className="card-title font-bold text-sm text-gray-600">Détails du prestataire</h3>
            <Input.Display label="Téléphone" value={item.telephone ? formatPhoneNumber(item.telephone) : 'Non renseigné'} 
              className="flex flex-wrap items-center"
            />
            <Input.Display label="Email"
              className="flex flex-wrap items-center"
            >
              <EmailLink email={item.email} />
            </Input.Display>

            <Input.Display label="Adresse" forceEmptyPlaceholder={true}
              className="flex flex-wrap items-center"
            >
              <Address data={item} />
            </Input.Display>
          </div>
          <div className='flex justify-end'>
            <button className="btn btn-sm btn-ghost btn-square p-2 hover:bg-primary-400"
              title="Modifier le prestataire"
              onClick={openModal}
            >
              <PencilIcon />
            </button>
          </div>
        </div>
      </div>
    </div>
  )

  return (
    <div className="relative">
      { withLabel ? 
        <Input.Display label="Prestataire"><Content/></Input.Display> :
        <Content/>
      }
      <Modal
        open={isOpen}
        onClose={closeModal}
        ref={dialogRef}
        backdrop={true}
        className="max-w-full rounded-none"
      >
        <Modal.Header showCloseButton={true} />
        <Modal.Body>
          <Form onSuccess={closeModal} onClose={closeModal}/>
        </Modal.Body>
      </Modal>
    </div>
  )
}